import React, { useEffect } from 'react';
import { ItemsProgramaAnualAdquisiciones } from '../../json/ItemsProgramaAnualAdquisiciones';
import '../InformacionInstitucional/estilos.css';

  const ProgramaAnualAdquisiciones = () => {
        useEffect(() => {
          window.scrollTo(0, 0);
  },[]); 

  return (
    <div className='container'>
        <div className='row'>
          <div className='ldf_titulo'>
            <h2>Programa Anual de Adquisiciones, Arrendamientos y Servicios</h2>
            <hr className='hr-gob'/>
          </div>

          <div className="contenedor-tablaPAAAyS">
            <table className="table table-striped">
                    <tbody>
                       {
                        ItemsProgramaAnualAdquisiciones.map((item, index)=>(
                          <tr key={ index }>
                              <th><div className="detalle_iPAAAyS"><i className="bi bi-file-earmark-pdf-fill"></i></div></th>
                              <th scope="row">
                                <div className="detalle_documentoPAAAyS"> { item.nombre } </div>
                              </th>
                              <td>
                                <div>
                                    <a href={ item.linkPDF } target="_blank" rel="noopener noreferrer"><button class="btn btn-default btn-pdf" type="button">PDF</button></a>
                                </div>
                              </td>
                          </tr>
                        ))
                       }
                  </tbody>
              </table>
          </div>         
       </div>
    </div>
    )
}

export default ProgramaAnualAdquisiciones